import GenericBadge from 'components/Utils/GenericBadge';
import MiscUtils from 'services/MiscUtils';
import Icon from 'components/Utils/NewIcon';
import React from 'react';
import { ClinicInfo } from 'generated/api/models/ClinicInfo';
import './style.scss';

interface PatientClinicBadgeProps {
  clinic: ClinicInfo | null | undefined;
  onClick?: (clinic: ClinicInfo) => void;
  selected?: boolean;
  icon?: string;
  children?: React.ReactNode;
  extraInfo?: React.ReactNode;
  showOwnClinic?: boolean;
  isOwnClinic?: boolean;
}

const PatientClinicBadge: React.FC<PatientClinicBadgeProps> = ({
  clinic,
  onClick,
  selected,
  icon = 'location-dot',
  children,
  extraInfo = null,
  showOwnClinic = false,
  isOwnClinic = false,
}) =>
  clinic ? (
    <div className={'patient-clinic-badge-wrapper' + (selected ? ' is-selected' : '')}>
      <GenericBadge
        className="patient-clinic-badge"
        title={clinic.name || 'Unnamed'}
        info={
          <>
            <span>{MiscUtils.getFullAddress(clinic.address, false, ['state', 'country'])}</span>
            {showOwnClinic && isOwnClinic && (
              <div className="misc">
                <span className="your-clinic-badge">Your Clinic</span>
              </div>
            )}
            {extraInfo}
          </>
        }
        avatar={<Icon src={icon} className="location" fontAwesomeStyle="fad" width="30px" />}
        onClick={onClick ? () => onClick(clinic) : undefined}
      >
        {children}
      </GenericBadge>
    </div>
  ) : null;

export default PatientClinicBadge;
